module.exports = __webpack_public_path__ + "static/media/d43@2x.c349aaee.png";